const app = angular.module('stcPlugin', [])

const lunchBoxImages = {};

const DEBUG = false;
const dirScope = DEBUG ? "@" : "=";

app.directive('lunchboxDir', () => {
  const controller = ['$scope', '$element', '$rootScope', ($scope, $element) => {
    $scope.fruit = parseAnswer($scope.vm.fruit);
    $scope.sandwich = parseAnswer($scope.vm.sandwich);
    $scope.dessert = parseAnswer($scope.vm.dessert);
    $scope.note = $scope.vm.note;
    $scope.canvas = $element.find("canvas")[0];
  
    function parseAnswer(answer) {
      let regex = /<div id="(.*?)">/;

      if (DEBUG) {
        return answer;
      } else {
        return answer.match(regex)[1].trim();
      }
    }

    const checkPreLoad = () => {
      var foundUnloadedImage = false;
      var foundUnloadedFonts = false;
      for (let img in lunchBoxImages) {
        if (!lunchBoxImages[img].complete) {
          foundUnloadedImage = true;
          lunchBoxImages[img].onload = checkPreLoad
        }
      }
      if (!document.fonts.check('38pt professor')) {
        foundUnloadedFonts = true;
        document.fonts.onloadingdone = checkPreLoad
      }
      if (!foundUnloadedImage) {
        renderCanvas(
          $scope.canvas,
          $scope.fruit,
          $scope.sandwich,
          $scope.dessert,
          $scope.note
        )
        window.scroll(0,0);
      }
    }
  
    $scope.$watch('$viewContentLoaded', () => {
      checkPreLoad({$scope, $element});
    });

    const preloadFont = (font, fontWeight)  => {
      const div = document.createElement("DIV");
      div.innerText = "font preloader";
      Object.assign(div.style, {position: "relative", left: "-9999px", fontFamily: font, fontWeight: fontWeight || "normal"});
      document.body.appendChild(div);
    }
  
    const preloadImage = (src) => {
      const img = new Image();
      img.src = `/adhoc/stc-lunchbox/static/img/${src}`;
      lunchBoxImages[src] = img;
    }

    const initPreload = () => {
      [
        'professor'
      ].forEach(preloadFont);

      [
        'lunchbox-blank.png',
        'note.png',
        'apple.png',
        'brownie.png',
        'cherries.png',
        'cookie.png',
        'cupcake.png',
        'grapes.png',
        'hamsandwich.png',
        'hummuscucumber.png',
        'orange.png',
        'pbj.png',
        'strawberries.png',
        'turkeysandwich.png'
      ].forEach(preloadImage);
    }
  
    initPreload();
  }]

  return {
    restrict: 'E',
    scope: {
      fruit: dirScope,
      sandwich: dirScope,
      dessert: dirScope,
      note: dirScope
    },
    template: `
      <canvas></canvas>
    `,
    bindToController: true,
    controllerAs: "vm",
    controller: controller
  }
})